module.exports = __webpack_public_path__ + "static/komercja-cb17717a38b491bb39be65e3fbbb77b3.jpg";